const config = require('../config.yaml');
const Tools = require('./Tools.js');
const Hourglass = require('./Hourglass.js');
const PieSpinner = require('./PieSpinner.js');
const ProjectsSliderController = require('./ProjectsSliderController.js');
const ProgressBarController = require('./ProgressBar.js');
const Promise = require('bluebird');

const DEBUG = Boolean(!templateVars.production);

/**
 * Класс для управления заголовочной линией
 */
class SliderController {
	constructor() {
		this.slider = $('#mainpage-slider'); //главный контейнер
		this.sliderItems = this.getSliderItems(); //элементы
		this.mainSliderInstance = false; //инстанс слайдера главного слайдера
		this.hourglassController = false; //инстранс класса hourglass
		this.hourglassSliderInstance = false; //инстранс hourglass-слайдера
		this.projectsSliderController = false; //инстранс класса projects
		this.projectsSliderInstance = false; //инстранс pieChart-элемента
		this.pieChartController = false; //инстранс pieChart-элемента
		this.progressBarController = false; //инстанс progressBar-контроллера

		this.playStopController = $('#mainpage-play-stop-controller');
	}

	/**
	 * Инициализация для play-stop контроллера
	 */
	initPlayStopControllerEvent() {
		//кнопка play-stop
		if (this.playStopController) {
			this.playStopController.on('click touch', () => {
				//получаем статус контроллера
				const isPlay = this.playStopController.hasClass('is-play');

				if (isPlay) {
					this.setPlayStopControllerStopState();
				} else {
					this.setPlayStopControllerPlayState();
				}

				return false;
			});
		} else {
			if (DEBUG) {
				Tools.log('cSlideLineController: initPlayStopClickEvent', 'Не найден play-stop контроллер');
			}
		}
	}

	/**
	 * Выставляем классы play-state для play-stop контроллера
	 */
	setPlayStopControllerPlayClasses() {
		if (this.playStopController) {
			this.playStopController.removeClass('is-stop');
			this.playStopController.addClass('is-play');
		} else {
			if (DEBUG) {
				Tools.log('cSlideLineController: setPlayStopControllerToPlay', 'Не найден play-stop контроллер');
			}
		}
	}

	/**
	 * Выставляем классы stop-state для play-stop контроллера
	 */
	setPlayStopControllerStopClasses() {
		if (this.playStopController) {
			this.playStopController.removeClass('is-play');
			this.playStopController.addClass('is-stop');
		} else {
			if (DEBUG) {
				Tools.log('cSlideLineController: setPlayStopControllerToPlay', 'Не найден play-stop контроллер');
			}
		}
	}

	isPlayStopControllerStopState() {
		return this.playStopController.hasClass('is-stop');
	}

	isPlayStopControllerPlayState() {
		return this.playStopController.hasClass('is-play');
	}

	/**
	 * Выставляет классы для play-stop контроллера в состоянии Play
	 */
	setPlayStopControllerPlayState() {
		//получаем текущий слайд
		const currentSlideID = this.getMainCurrentSlideID();

		if (currentSlideID != undefined) {
			//выставляем классы на Play
			this.setPlayStopControllerPlayClasses();

			switch (String(currentSlideID)) {
				case '0':
					//запускаем слайды в первом глобальном слайде
					this.hourglassSliderInstance.startAutoplay();

					break;
				case '1':
					//запускаем вращение круговой диаграммы
					this.pieChartController.startSpin();

					break;
				case '2':
					//запускаем слайды cлайдера проектов
					this.projectsSliderInstance.startAutoplay();

					break;
				case '3':

					break;
			}
		} else {
			if (DEBUG) {
				Tools.log('cSlideLineController: setPlayStopControllerPlayState', 'Не найден id для текущего активного слайда');
			}
		}
	}

	/**
	 * Выставляет классы для play-stop контроллера в состоянии Stop
	 */
	setPlayStopControllerStopState() {
		//получаем текущий слайд
		const currentSlideID = this.getMainCurrentSlideID();

		if (currentSlideID != undefined) {
			//выставляем классы на Stop
			this.setPlayStopControllerStopClasses();

			switch (String(currentSlideID)) {
				case '0':
					//стопим слайды в первом глобальном слайде
					this.hourglassSliderInstance.stopAutoplay();

					break;
				case '1':
					//стопим вращение круговой диаграммы
					this.pieChartController.stopSpin();

					break;
				case '2':
					//стопим слайды cлайдера проектов
					this.projectsSliderInstance.stopAutoplay();

					break;
				case '3':

					break;
			}
		} else {
			if (DEBUG) {
				Tools.log('cSlideLineController: setPlayStopControllerStopState', 'Не найден id для текущего активного слайда');
			}
		}
	}

	/**
	 * Возращает ID текущего слайда в глобальном слайдере
	 * @returns {*}
	 */
	getMainCurrentSlideID() {
		let $slide = this.sliderItems.filter((key, item) => {
			return $(item).hasClass(this.mainSliderInstance.params['slideActiveClass'])
				|| $(item).hasClass(this.mainSliderInstance.params['slideDuplicateActiveClass']);
		});

		if ($slide.length) {
			return $slide.attr('data-slide-id');
		} else {
			return false;
		}
	}

	/**
	 * Получить все слайды главного слайдера
	 */
	getSliderItems() {
		if (this.slider.length) {
			return this.slider.find('[data-slide-id]');
		} else {
			if (DEBUG) {
				Tools.log('cSlideLineController: getSliderItems', 'Не найден контейнер-слайдер');
			}
		}
	}

	/**
	 * Получить элемент по переданному ID
	 * @param id
	 */
	getSliderItemByID(id) {
		if (this.sliderItems.length) {
			return this.sliderItems.filter((key, item) => {
				return $(item).attr(`data-slide-id`) == id;
			});
		} else {
			if (DEBUG) {
				Tools.log('cSlideLineController: getSliderItemByID', 'Не найден контейнер-слайдер');
			}
		}
	}

	/**
	 * Проверяет, существует ли элемент слайдера по переданному ID
	 * @param id
	 */
	isExistSlideByID(id) {
		if (this.sliderItems.length) {
			return this.sliderItems.filter((key, item) => {
				return $(item).attr(`data-slide-id`) == id;
			}).length;
		} else {
			if (DEBUG) {
				Tools.log('cSlideLineController: isExistSlideByID', 'Не найден контейнер-слайдер');
			}
		}
	}

	/**
	 * Возвращает ID слайда по его хешу.
	 * @param addressHash - целевой хэш
	 * @returns {int} | {boolean}
	 */
	getSlideIDByHash(addressHash) {
		let $targetSlide = this.sliderItems.filter((key, item) => {
			let slideHash = $(item).attr(`data-slide-hash`);

			return (slideHash == addressHash)
				? true
				: (slideHash == '#' + addressHash);
		});

		return ($targetSlide.length) ? $targetSlide.attr('data-slide-id') : false;
	}

	/**
	 * Возвращает хэш элемента по его ID
	 * @param id - id элемента
	 * @returns {int} | {boolean}
	 */
	getHashBySlideID(id) {
		let $targetSlide = this.sliderItems.filter((key, item) => {
			return $(item).attr(`data-slide-id`) == id;
		});

		return ($targetSlide.length) ? $targetSlide.attr('data-slide-hash') : false;
	}

	/**
	 * Возвращает хеш глобального слайда + хеш текущего элемента из интерактивного содержимого
	 * @param id - id основного элемента слайда
	 */
	getFullHashBySlideID(id) {
		let $targetSlide = this.sliderItems.filter((key, item) => {
			return $(item).attr(`data-slide-id`) == id;
		});

		if ($targetSlide.length) {
			let mainSlideHash = $targetSlide.attr('data-slide-hash');
			let interactiveItemHash = '';
			let interactivePackID = $targetSlide.attr('data-interactive-id');

			switch (interactivePackID) {
				case '0':
					interactiveItemHash = this.hourglassController.getHashByCurrentSlide();
					break;
				case '1':
					interactiveItemHash = this.pieChartController.getHashByCurrentSector();
					break;
				case '2':
					interactiveItemHash = this.projectsSliderController.getHashByCurrentSlide();
					break;
				case '3':

					break;
			}

			if (interactiveItemHash) {
				return Tools.jointHashByDelimiter([mainSlideHash, interactiveItemHash]);
			} else {
				return mainSlideHash;
			}
		} else {
			return false;
		}
	}

	/**
	 * Возвращает все слайды, где есть внутренняя анимация
	 */
	getInteractiveSlides() {
		if (this.sliderItems.length) {
			return this.sliderItems.filter((key, item) => {
				return $(item).attr(`data-interactive-id`);
			}).toArray();
		} else {
			if (DEBUG) {
				Tools.log('cSlideLineController: getSliderItemByID', 'Не найден контейнер-слайдер');
			}
		}
	}

	/**
	 * Возвращает слайд с внутренней анимацией по его ID
	 * @param id - id интерактивного слайда
	 */
	getInteractiveSlideByID(id) {
		if (this.sliderItems.length) {
			return this.sliderItems.filter((key, item) => {
				return $(item).attr(`data-interactive-id`) == id;
			});
		} else {
			if (DEBUG) {
				Tools.log('cSlideLineController: getSliderItemByID', 'Не найден контейнер-слайдер');
			}
		}
	}

	/**
	 * Инициализирует анимации внутри каждого интерактивного слайда
	 * @returns {Promise.<T>|*}
	 */
	initInteractivePacks() {
		return Promise.resolve(this.getInteractiveSlides())
			.mapSeries((item) => {
				const $item = $(item);

				return new Promise((resolve, reject) => {
					let interactivePackID = $item.attr('data-interactive-id');

					switch (interactivePackID) {
						//внутренний интерактив для первого слайда
						case '0':
							this.hourglassController = new Hourglass(this);

							this.hourglassController.initSlider()
								.then((sliderInstance) => {
									this.hourglassSliderInstance = sliderInstance;
									resolve();
								});
							break;
						case '1':
							this.pieChartController = new PieSpinner(config.slidesInteractiveParams['slide-2'], DEBUG);
							// this.pieChartController.stopSpin();

							this.pieChartController.onBeforeRotateNextStart = ($targetSector) => {
								//Выставляем play-stop контроллер в состояние Play
								this.setPlayStopControllerPlayState();
								//прокручиваем progress-bar на нужное положение
								this.progressBarController.fillSection(
									this.getMainCurrentSlideID(),
									$targetSector.attr('data-sector-id-for-progress-bar')
								);
							};

							this.pieChartController.onAfterRotateNext = ($targetSector) => {
								//переключение хеша в адресной строке
								let slideHash = this.getFullHashBySlideID(this.getMainCurrentSlideID());
								if (slideHash) {
									Tools.setPageHash(slideHash);
								}
							};

							this.pieChartController.onAutoSpinToNullItemCompleted = () => {
								this.pieChartController.stopSpin();
								this.mainSliderInstance.slideNext();
							};

							//этим обработчиком будет томрозить промотку слайдера, когда мы вне второго слайда
							$(document).on('stopMainpageSliderInnerInteractive', (e, params) => {
								this.pieChartController.stopSpin();
							});

							resolve();
							break;
						case '2':
							this.projectsSliderController = new ProjectsSliderController(this);

							this.projectsSliderController.initSlider()
								.then((slideInstance) => {
									this.projectsSliderInstance = slideInstance;

									resolve();
								});
							break;
						case '3':
							// console.log('3');
							resolve();
							break;
						default:
							resolve();
					}
				});
			})
			.catch((e) => {
				if (DEBUG) {
					Tools.log('cSlideLineController: initAnimationPacks', e);
				}
			});
	}

	/**
	 * Перезапуск пака анимации по его ID
	 */
	resetInteractivePack(interactivePackID) {
		if (interactivePackID != 'undefined') {
			//тормозим другие слайдерные интерактивы и запускаем новый
			$(document).trigger('stopMainpageSliderInnerInteractive', {
				interactivePackID: interactivePackID
			});

			//Выставляем play-stop контроллер в состояние Play
			this.setPlayStopControllerPlayState();

			switch (String(interactivePackID)) {
				//внутренний интерактив для первого слайда
				case '0':
					const $hourglassSlider = $('#hourglass-slider');

					if ($hourglassSlider.length) {
						this.hourglassSliderInstance.slideTo(0, 0);
						// this.hourglassSliderInstance.reInit();
						// this.hourglassSliderInstance.resizeFix();
						this.hourglassSliderInstance.startAutoplay();
					} else {
						reject(`Не найден контейнер слайдера для пака ${interactivePackID}`);
					}
					break;
				case '1':
					this.pieChartController.reset();

					break;
				case '2':
					const $projectsSlider = $('#mainpage-project-slider');

					if ($projectsSlider.length) {
						this.projectsSliderInstance.slideTo(0, 0);
						// swiper.reInit();
						// swiper.resizeFix();
						this.projectsSliderInstance.startAutoplay();
					} else {
						reject(`Не найден контейнер слайдера для пака ${interactivePackID}`);
					}

					break;
				case '3':

					break;
				default:
					if (DEBUG) {
						Tools.log(`Не найден пак анимации ${interactivePackID}`);
					}
			}
		} else {
			if (DEBUG) {
				Tools.log('cSlideLineController: resetInteractivePack', 'Не передан ID пака анимации');
			}
		}
	}

	/**
	 * Переход к основному слайд и переключение его внутреннего содержимого на нужны элемент. Адреса переключения
	 * задаются в параметре
	 * @param arHash - массив параметров для перехода. Под первым ключем - основной слайд. Под вторым - внутренний.
	 */
	goToSlideByHash(arHash = []) {
		let $slide = $(this.getSlide(this.mainSliderInstance.activeIndex));
		let slideRealIndex = $slide.attr('data-slide-id');


		//получение ID слада по хешу
		let hashSlideID = this.getSlideIDByHash(arHash[0]);

		//если мы на первом слайде, то нужно прогнать все анимации
		//сперва переключаем первый слайд
		if (hashSlideID == 0) {
			// запуск пака анимации для первого слайда
			this.resetInteractivePack(slideRealIndex);
		} else if (typeof hashSlideID != 'undefined') {
			this.mainSliderInstance.slideTo(hashSlideID, 0);
		}
		//определяем и переключаем второй слайд (если задан)
		if (typeof arHash[1] != 'undefined') {
			switch (hashSlideID) {
				case '0':
					this.hourglassController.goToSlideByHash(arHash[1]);
					//ставим на паузу все анимации через контроллер
					this.setPlayStopControllerStopState();
					break;
				case '1':
					this.pieChartController.goToSectorByHash(arHash[1])
						.then(() => {
						//ставим на паузу все анимации через контроллер
							this.setPlayStopControllerStopState();
						});
					break;
				case '2':
					this.projectsSliderController.goToSlideByHash(arHash[1]);
					//ставим на паузу все анимации через контроллер
					this.setPlayStopControllerStopState();
					// break;
				case '3':
					break;
			}
		}
	}

	getSlide(index) {
		return this.sliderItems[index];
	}

	/**
	 * Условная блокировка слайдера классом.
	 * Полезно на время выполнения сложных анимаций
	 */
	lockSlider() {
		this.slider.addClass('is-locked');
	}

	/**
	 * Снятие условной блокировки слайдера классом
	 */
	unlockSlider() {
		this.slider.removeClass('is-locked');
	}

	/**
	 * Проверяет, блокирован ли слайдер
	 * @returns {*}
	 */
	isLockSlider() {
		return this.slider.hasClass('is-locked');
	}

	/**
	 * Создание progressBar
	 */
	buildProgressBar() {
		this.progressBarController = new ProgressBarController(this);
	}
}

module.exports = SliderController;



// WEBPACK FOOTER //
// ./temp/components/mainpage/classes/SliderController.js